let trayaProcessingAnimation = document.getElementById('traya-processing-animation');
var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1), sURLVariables = sPageURL.split('&'), sParameterName, i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
};
var id = getUrlParameter('id'), f_name, C_number, C_email, user__gender, user_gender, userHairStage, caseId, pdPrice = 0, strikeFinalCartPrice = 0, hairStage;
var cohort = getUrlParameter('cohort'), factors = [];
if(id) {
  localStorage.setItem('user-gender', 'female');
  localStorage.setItem('rid', id);
}
id = localStorage.getItem('rid');
if(id == undefined) {
  id = getCookie('syntheticId');
}
(function() {
  if(!id) {
    if(window.location.pathname == '/pages/result4'){
      alert('Your recommendation is not found. Please fill the diagnosis to help us share the recommended plan.');
      document.location.href= 'https://form.traya.health/questions?cohort=1&source=ResultPage'
    }
  }else
    setotherCookie('syntheticId', id, 30, '.traya.health');
    var baseUrls = {
      DEV: 'https://api.dev.hav-g.in/',
      PROD: 'https://api.hav-g.in/'
    }
    var tokens = {
      DEV:{ 
        "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d"
      },
      PROD: { 
        "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
      }
    }
    var token = tokens.PROD;
    var baseUrl = baseUrls.PROD;
    var liveendpoint = 'https://api.hav-g.in/dgReport/female?id=';
    liveendpoint = `${baseUrl}dgReport/female?id=`
    getFemaleResult(liveendpoint, id, token);
})();

// CAPI_TRACKING_API code
function trackMetaEvent(response, eventName) {
  function getCookieValue(cookieName) {
    const cookie = document.cookie.split(';').find(c => c.trim().startsWith(cookieName + '='));
    if (!cookie) return null;
    return cookie.trim().split('=').slice(1).join('=');
  }
  
  const fbp = getCookieValue('_fbp');
  const fbc = getCookieValue('_fbc');
  const user_gender = response.gender;
  const email = response.email;
  const phone = response.phone;
  
  const capiBody = {
    eventName: eventName,
    eventTime: Date.now(),
    email: email,
    phone: phone,
    fbc: fbc,
    fbp: fbp,
    url: window.location.href,
    domain: "traya.health",
    gender: user_gender
  };
  
  const CAPI_TRACKING_API = {
    Dev: 'https://public-zxhj2.dev.hav-g.in/',
    PROD: 'https://public-jgfas325.hav-g.in/'
  };
  
  const bearerTokens = {
    DEV: { "Authorization": "Bearer e2623576-930b-48b6-81e2-a3cb5e37f47d" },
    PROD: { "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90" }
  };
  
  fetch(`${CAPI_TRACKING_API.PROD}tracking`, { method: 'POST', body: JSON.stringify(capiBody), headers: {
      "Content-Type": "application/json",
      ...bearerTokens.PROD
    }
  });
}

function getFemaleResult(liveendpoint, id, token) {
  document.body.style.overflow = "hidden";
  fetch(`${liveendpoint}${id}&isWebsite=true`, {
    headers: token,
  })
  .then((response) => {
    if (response.status === 400 || response.status !== 200) {
      window.location.href = "https://form.traya.health/questions?cohort=1&location=HomeSlideshow&page=home&user=notfound";
      return;
    }
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return response.json();
  })
  .then((response) => {
    if (Object.keys(response).length === 0) {
      window.location.href = "https://form.traya.health/questions?cohort=1&location=HomeSlideshow&page=home&user=notfound";
      return;
    }
    if (response.message && response.message === "Report is only for male") {
      const queryParams = window.location.search;
      window.location.href = `/pages/result4${queryParams}`;
      return;
    }
    if (response.message && response.message === "Report is only for male") {
      const queryParams = window.location.search;
      window.location.href = `/pages/result4${queryParams}`;
      return;
    }
    const caseId = response?.User_Analysis?.case_id;
    const hairStage = response?.User_Analysis?.hair_fall_stage?.toLowerCase();
    userHairStage = hairStage;
    const customValidStage = hairStage === "widening" || hairStage === "coin size patches" ||  hairStage === "coin sized patches" || hairStage === "alopecia areata";
    const validStage = hairStage === "hair thinning" || hairStage === "side thinning" || hairStage === "no widening";
    const queryString = window.location.search;
    const universalCaseIds =  caseId && /^[0-7]/.test(caseId);
    // const optionalProductsCaseId =  caseId && /^[0-7]/.test(caseId);
    let formFillDateStr = response?.User_Analysis?.case_created_date;
    let formFillDate = new Date(formFillDateStr);

    if (isNaN(formFillDate.getTime())) {
      formFillDateStr = getCookie('current_D0_date');
      formFillDate = new Date(formFillDateStr);
    }

    const today = new Date();   
    today.setHours(0, 0, 0, 0);
    const validCase = caseId && /^[a-d]/.test(caseId);
    const valiedChatCase =  caseId && /^[0-7]/.test(caseId);
    if (!isNaN(formFillDate.getTime())) {
      if (formFillDate < today) {
        const wrapper = document.querySelector('.whats-app-wrapper');
        if(valiedChatCase){
          wrapper.classList.remove('d-none');
          initWhatsAppTooltipAnimation();
        } else {
          const normalUserWrapper = document.querySelector('.whats-app-wrapper-normal-user');
          if (!normalUserWrapper) return;
          normalUserWrapper.classList.remove('d-none');
        }
        const chatIconClick = document.querySelectorAll('.chat-icon-click-event');
        chatIconClick.forEach((clicked)=>{
          clicked.addEventListener('click', ()=>{
            if(valiedChatCase){
              chatIconClicked("chat_icon_clicked_female_test", caseId);
            }
          })
        })
      }
    }
    
    const isUniversalCustomStage =  hairStage === "alopecia areata" || hairStage === "advanced widening" ||  hairStage === "medium widening" ;
    const isOtherCustomStage = hairStage === "widening" || hairStage === "medium widening" || hairStage === "advanced widening" || hairStage === "coin size patches" || hairStage === "coin sized patches" || hairStage === "alopecia areata"
    if (isOtherCustomStage) {
      window.location.href = '/pages/female-result2' + queryString;
    } else if (validStage) {
      // March page at 100% of thinning: route straight to v2, skipping the
      // female-result4 hop (its JS would re-redirect there anyway)
      window.location.href = '/pages/female-result-4-v2' + queryString;
    }
    trackMetaEvent(response.User_Analysis, "Viewed Content");
    rootCause(response?.root_causes);
    showContent(response);
  })
  .catch((error) => {
    if (error.message.includes("400")) {
      window.location.href = "https://form.traya.health/questions?cohort=1&location=HomeSlideshow&page=home&user=notfound";
    }
    console.error("Network Error: ", error);
  })
  .finally(() => {
    clearCart();
    document.body.style.overflow = "unset";
  });
}

function rootCause (response) {
  const primaryRootCause = response?.primaryRootCause ?? [];
  const defaultRootCause = response?.defaultRootCause ?? [];
  let primaryRootCauseHtml = '';
  let primaryRootCauseContentHtml = '';
  if (primaryRootCause.length > 0) {
    primaryRootCauseHtml = `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border active text-center" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tab" aria-controls="${primaryRootCause[0]?.title.replace(/ /g, "-")}" aria-selected="true">
        <div class="rootCauseLinkImg">
          <img src="${primaryRootCause[0]?.details?.icon}" width="32px" height="32px" loading="eager"/>
        </div>
        <p class="mt-2">${primaryRootCause[0]?.title}</p>
      </a>
    </li>`;
  }
  if (primaryRootCause.length > 0) {
    primaryRootCauseContentHtml = `<div class="tab-pane fade show active" id="${primaryRootCause[0]?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${primaryRootCause[0]?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${primaryRootCause[0]?.details?.description?.english}</p>
    </div>`;
  }
  const defaultRootCauseHtml = defaultRootCause.map((item) => {
    return `<li class="rootCause-nav-item" role="presentation">
      <a class="rootCause-nav-link border text-center" id="${item?.title.replace(/ /g, "-")}-tab" data-toggle="tab" href="#${item?.title.replace(/ /g, "-")}" role="tab" aria-controls="${item?.title.replace(/ /g, "-")}" aria-selected="false">
        <div class="rootCauseLinkImg">
          <img src="${item?.details?.icon}" width="32px" height="32px" loading="eager"/>
        </div>
        <p class="mt-2">${item?.title}</p>
      </a>
    </li>`;
  }).join('');
  const defaultRootCauseContentHtml = defaultRootCause.map((item) => {
    return `<div class="tab-pane fade" id="${item?.title.replace(/ /g, "-")}" role="tabpanel" aria-labelledby="${item?.title.replace(/ /g, "-")}-tab">
      <p class="m-0">${item?.details?.description?.english}</p></div>`;
  }).join('');
  const rootCauseHtml = `<ul class="nav rootCause-nav-tabs border-0" id="myTab" role="tablist">${primaryRootCauseHtml}${defaultRootCauseHtml}</ul>
  <div class="tab-content rootCauseTabContent p-2 p-md-3 mt-3" id="myTabContent">${primaryRootCauseContentHtml}${defaultRootCauseContentHtml}</div>`;
  const rootCauseSectionWrapper = document.getElementById('rootCouseSectionWrapper');
  if (rootCauseSectionWrapper) {
    rootCauseSectionWrapper.innerHTML = rootCauseHtml;
  }
}

function chatIconClicked(eventName, caseID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}

function showContent(response) {
  var normalPage = document.querySelectorAll('[page_type="normal"]');
  var cuticlePage = document.querySelectorAll('[page_type="cuticle"]');
  var { User_Analysis, Recommendations, stageTransition, assessmentReport, hideAssesmentImage } = response;
  var RootCauses = response.root_causes.primaryRootCause[0];
  var User_Analysis_hair_fall =  User_Analysis.hair_fall_stage;
  const newHairFallStage = User_Analysis_hair_fall;
  const hairThinningWeekText = document.querySelector('.hair_thinning_week_text-container');
  const hairThinningWeekText2 = document.querySelector('.hair_thinning_week_text-container.d-md-none');
  const removeCustomPriceSection = document.querySelector('.custom-price-section');
  
  var tillImage = document.querySelector(".tillImage img"), toImage = document.querySelector(".toImage img"), toStageWiseimg = document.querySelector(".stageWise-img"),
    assist_report = document.querySelector(".assist_report strong"), mobileDescription = document.querySelector(".mobileDescription"),
     desktopDescription = document.querySelector(".desktopDescription");
    if (hideAssesmentImage === true) {
      if (toStageWiseimg) {
        toStageWiseimg.style.cssText = "display: none;";
      }
    } else {
      if(tillImage) tillImage.setAttribute("src", stageTransition.current);
      if(toImage) toImage.setAttribute("src", stageTransition.getYouHere);
    }
  if(User_Analysis_hair_fall.toLowerCase() === "coin size patches") {
    var toImageParent = document.querySelector(".toImage"), arrowImage = document.querySelector(".stageWise-img .arrow"), stageWiseimg = document.querySelector(".stageWise-img");
    if(toImageParent) toImageParent.classList.add("d-none");
    if(arrowImage) arrowImage.classList.add("d-none");
    if(stageWiseimg) stageWiseimg.classList.add("justify-content-center");
  }
  if(assist_report) assist_report.innerHTML = User_Analysis_hair_fall;
  const defaultText = "While coin size patches cannot be cured, we offer a kit to help maintain your hair. Results may be limited due to the advanced stage of female hair fall, but we are here to support you.";
  const isCoinSizePatches = User_Analysis_hair_fall.toLowerCase() === "coin size patches";
  const displayText = isCoinSizePatches
	? defaultText
	: assessmentReport?.assessmentReport?.replace(/\n/g, "<br>");
  if (mobileDescription) mobileDescription.innerHTML = displayText;
  if (desktopDescription) desktopDescription.innerHTML = displayText;
  if (User_Analysis_hair_fall == "No widening" || User_Analysis_hair_fall == "Starting to see widening") {
    let product_card_head = document.querySelectorAll(".product-section_heading-kit");
    product_card_head.forEach((e) => {
      if (window.innerWidth < 768) {
        e.innerHTML = "Your Customised <br> Hair Treatment Kit";
      } else {
        e.textContent = "Your Customised Hair Treatment Kit";
      }
    });
  }
  
  f_name = User_Analysis.first_name; 
  C_number = User_Analysis.phone; 
  strikeFinalCartPrice =  Math.round(response.newPriceCard.updatedCartPrice);
  setCookie('user_phone', C_number, 30)
  C_email = User_Analysis.email;
  user__gender = User_Analysis.gender;
  caseId = User_Analysis.case_id;
  localStorage.setItem('caseId', caseId);
  tagClarityCaseId(caseId);
  if(user__gender == 'F') {
    user_gender = 'Female';
  }
    displayStageSection(response);
    productComboKit(response);
    getProductByHandle(response);
    sectionMonthsExpectetion(response);
    sectionWomensStories(response);
    languageSelection();
  
    let goal = User_Analysis.goal;
    if(goal != null && goal != 'undefined'){
      goal = goal.replace('{"',"").replace(/","/g,", ").replace(/Anti-/g,'').replace(/More/g,'').replace('"}',"")
    }else {
     goal = 'Goal';
    }
    var root_cause = `Gut:${User_Analysis.gut}, Stress:${User_Analysis.stress}`, suffering_data = User_Analysis.suffering_from_conditions,
      hair_type = User_Analysis.hair_type, Stress = User_Analysis.stress, Genetics = User_Analysis.family_genetic,
      FamilyGenetics = User_Analysis.family_genetic, EnergyLevel = User_Analysis.energy_level, Digestion = User_Analysis.acidity_bloating_gas_indigestion,
      Lowthyroid = User_Analysis.suffering_from_conditions, vitamindefeciencies = User_Analysis.vitamin_defeciencies,
      show_treatment_months = response.show_treatment_months;
    if(show_treatment_months == true){
      var _newFresult = document.querySelectorAll('.new-fresult'), __customEssential = document.querySelectorAll('.custom-essential'),
        __female_concern_months = document.querySelectorAll('.female_concern_months'), __container_will_see = document.querySelectorAll('.container.will-see');
      if(_newFresult.length != 0) {showOrHideByClass(_newFresult, 'add', 'new-fresult_pd_true');}
      if(__customEssential.length != 0) {showOrHideByClass(__customEssential, 'add', 'custom_essential_pd_true');}
      if(__female_concern_months.length != 0) {
        showOrHideByClass(__female_concern_months, 'add', 'female_months_show');
        showOrHide(__female_concern_months, 'block');
      }
      if(__container_will_see.length != 0) {showOrHide(__container_will_see, 'none');}
    }
    var user__name = document.querySelectorAll('[data-user-name]'), __data_user_name_info = document.querySelectorAll('[data-user-name-info]'),
      scalpType = document.querySelectorAll('.femleBannerTTls [scalp-type]'), __hair_concern = document.querySelectorAll('.femleBannerTTls [hair-concern]'),
      __root__cause = document.querySelectorAll('.femleBannerTTls [root-cause]'), __primary_root = document.querySelectorAll('[primary-root]'),
      __mainFactImages = document.querySelectorAll('.root_cause_iconFR .mainFactImages'), __femaleMainFactImages = document.querySelectorAll('.root_cause_iconFRs .mainFactImages'),
      __rootcause_description = document.querySelectorAll('.RootCause .rootcause_description'), __formulation = document.querySelectorAll('.formulation .formulation-text');
    if(user__name.length != 0){user__name.forEach((name) => {name.textContent = `${User_Analysis.first_name}`});}
    if(__data_user_name_info.length != 0) {__data_user_name_info.forEach((info) => {info.textContent = `${User_Analysis.first_name}'s`})}
    if(scalpType.length != 0) {scalpType.forEach((scalp) => {scalp.textContent = `${User_Analysis.hair_type}`})}
    if(__hair_concern.length != 0) {__hair_concern.forEach((concern) => {concern.textContent = `${goal}`})}
    if(__root__cause.length != 0) {__root__cause.forEach((cause) => {cause.textContent = `${factors[0]}`})}
    if(__primary_root.length != 0) {__primary_root.forEach((root) => {root.textContent = `${factors[0]}`})}
    if(__mainFactImages.length != 0) {showOrHide(__mainFactImages, 'none');}
  
    var ATC_frp = document.querySelectorAll('#add-to-cart-result-page-frp'), stickyATC_frp = document.querySelectorAll('.sticky-btn #add-to-cart-result-page-frp'),
      ATC_rp = document.querySelectorAll('.add-to-cart-result-page');
    if(ATC_frp.length != 0) {
      ATC_frp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
    if(stickyATC_frp.length != 0) {
      stickyATC_frp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }
    if(ATC_rp.length != 0) {
      ATC_rp.forEach((rp) => {
        rp.setAttribute('user-mobile', User_Analysis.phone);
        rp.setAttribute('user-email', User_Analysis.email);
      });
    }

  let buyButtonElement = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonElement.forEach((eachBtn) => {
    eachBtn.addEventListener('click', () => {
       eachBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_3.svg?v=1741241123" class="loader-icon" alt="Loading...">`;
       eachBtn.classList.add('loader-added')
       eachBtn.disabled = true;
       trackMetaEvent(response.User_Analysis, "Expand Benefits");
       window.umami.track('buy_now_click', {
        syntheticId: window.location.search.substring(1).split('=')[1] || "default-id",
        fingerprintId: window.__deviceId
      });
      setTimeout(() => {
        if (window.appliedReferralCode) {
          window.location.href = `/checkout?discount=${window.appliedReferralCode}`;
        } else {
          window.location.href = '/checkout';
        }
      }, 100);
       setTimeout(() => {
         removeLoader();
      }, 2000);
    });
  });
  setTimeout(() => {
    if (trayaProcessingAnimation) {
      trayaProcessingAnimation.style.display = 'none';
    }
    document.body.style.overflow = 'unset';
  }, 1000);
  // explainer text 
  // const explainer = response?.productExplainer;
  // if (explainer?.title && explainer?.description?.length) {
  //   const containers = document.querySelectorAll('.explainers-text-flex');
  //   const textBlocks = document.querySelectorAll('.explainers-text');
  //   // containers.forEach(container => {
  //   //   container.classList.remove('d-none');
  //   // });
  //   const html = `
  //     <h3>${explainer.title}</h3>
  //     ${explainer.description.map(d => `<p>${d.text}</p>`).join('')}
  //   `;
  //   textBlocks.forEach(block => {
  //     block.innerHTML = html;  // reset + insert
  //   });
  // }
}

function showRegimenSection(productData, kits) {
  if (!Array.isArray(productData) || !Array.isArray(kits)) return;

  // collect variant IDs from API
  const recommendedVariantIds = productData.map(item =>
    String(item.product_id)
  );

  let matchedKit = null;

  // find matching kit
  for (let i = 0; i < kits.length; i++) {
    const kit = kits[i];
    let isMatch = true;

    for (let j = 0; j < kit.variantIds.length; j++) {
      if (!recommendedVariantIds.includes(String(kit.variantIds[j]))) {
        isMatch = false;
        break;
      }
    }

    if (isMatch) {
      matchedKit = kit;
      break;
    }
  }

  if (!matchedKit) return;

  // update UI
  const section = document.getElementById("regimen-2x2-section");
  const mobileImg = document.getElementById("regimen-mobile-img");
  const desktopSource = document.getElementById("regimen-desktop-img");

  if (mobileImg) mobileImg.src = matchedKit.mobileImg;
  if (desktopSource) desktopSource.srcset = matchedKit.desktopImg;
  if (section) section.classList.remove('d-none');
}

const FEMALE_KITS = [
  {
    id: "kit1",
    variantIds: [47300731568306, 47302951403698, 45277154377906, 47301139169458, 47303097352370],
    mobileImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle1_mobile.webp",
    desktopImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle1_desktop.webp"
  },
  {
    id: "kit2",
    variantIds: [47300731568306, 47302951403698, 45277154377906, 47303079166130, 47303097352370],
    mobileImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle2_mobile.webp",
    desktopImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle2_desktop.webp"
  },
  {
    id: "kit3",
    variantIds: [46528923304114, 47302951403698, 45277154377906, 47303079166130, 47303097352370, 47301151064242],
    mobileImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle3_mobile.webp",
    desktopImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle3_desktop.webp"
  },
  {
    id: "kit4",
    variantIds: [46528923304114, 47302951403698, 45277154377906, 47301139169458, 47303097352370, 47301151064242],
    mobileImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle4_mobile.webp",
    desktopImg:
      "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/bundle4_desktop.webp"
  }
];

function displayStageSection(response) {
  // showRegimenSection(response.product_Ids, FEMALE_KITS);
  const stageImages = {
    "hair thinning": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_c2a537bc-4919-4b83-a12f-3767cb8d1b25.webp?v=1756899713",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_3bca6c41-ac7a-4ec8-9a57-43b2dd498985.webp?v=1756899713",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_7d151296-1377-4a5c-b218-da4db4a72c4c.webp?v=1756899713"
        
      ],
      customerName: "Sakshi"
    },
    "widening" : {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_906439c7-0777-4323-a6fb-54e2226571be.webp?v=1756899831",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_385b4e21-187d-4c80-bf27-4de49bb8b384.webp?v=1756899831",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1f4670c5-e3be-47a5-8890-fb50592e1dac.webp?v=1756899831"
      ],
      customerName: "Poonam"
    },
    "advanced widening": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_2_a6008d93-33ea-4539-a4f3-0a31b1e81546.webp?v=1756988341",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_2.webp?v=1756988341",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1_5371c479-d809-4fc5-bd81-c1d1e6535b23.webp?v=1756988341"
      ],
      customerName: "Pratima"
    },
    "side thinning": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_0f684d2e-9d4b-4fc8-9c86-839c3d112433.webp?v=1756900221",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_a54b4d61-d7b0-449b-80a5-8b8c7aeb624c.webp?v=1756900221",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_1_0c8e0bca-7f44-40be-a1b5-5304dafe1c46.webp?v=1756900220"
      ],
      customerName: "Anjali"
    },
    "coin size patches": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_6041ce02-9314-4e64-8aff-668a3eba433a.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_dd3429b7-2edc-4dd8-8d98-bd019141c6c0.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_4aeb8cec-257c-454d-8434-548a24b29258.webp?v=1756900342"
      ],
      customerName: "Supriya"
    },
    "alopecia areata": {
      images: [
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image_1_6041ce02-9314-4e64-8aff-668a3eba433a.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-1_1_dd3429b7-2edc-4dd8-8d98-bd019141c6c0.webp?v=1756982697",
        "https://cdn.shopify.com/s/files/1/0100/1622/7394/files/Image-2_4aeb8cec-257c-454d-8434-548a24b29258.webp?v=1756900342"
      ],
      customerName: "Supriya"
    }
  };

  const userStageRaw = response.User_Analysis.hair_fall_stage;
  const userStage = userStageRaw?.toLowerCase();
  console.log("User stage from response:", userStage);

  // Find matching stageData with case-insensitive key comparison
  let stageData = null;
  for (const stageKey in stageImages) {
    if (stageKey.toLowerCase() === userStage) {
        stageData = stageImages[stageKey];
        break;
    }
  }
  console.log("User stage from response:", userStage);

  const stageContainer = document.getElementById("stageContainer");
  stageContainer.innerHTML = ""; 
  
  if (stageData && stageData.images.length > 0) {
    const p1 = document.createElement("p");
    p1.textContent = "Here’s someone like you";
    p1.className = "custome-stage-heading";
    stageContainer.appendChild(p1);

    const p2 = document.createElement("p");
    p2.textContent = `${stageData.customerName} was unsure, but she stayed consistent`;
    p2.className = "custome-stage-subheading";
    stageContainer.appendChild(p2);

    const imageWrapper = document.createElement("div");
    imageWrapper.className = "stage-image-wrapper";

    let arrowSvgImage = `<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
        <path d="M0.902344 16C0.902344 7.16344 8.06579 0 16.9023 0C25.7389 0 32.9023 7.16344 32.9023 16C32.9023 24.8366 25.7389 32 16.9023 32C8.06579 32 0.902344 24.8366 0.902344 16Z" fill="#EDD2CE"/>
        <path d="M13.7021 22.3984L20.1021 15.9984L13.7021 9.59844" stroke="#262626" stroke-width="1.6"/>
      </svg>`;

    stageData.images.forEach((imgUrl, index) => {
      const img = document.createElement("img");
      img.src = imgUrl;
      img.alt = userStage;
      img.className = "scrollable-stage-image";
      img.loading = "lazy";
      imageWrapper.appendChild(img);
    
      // Add arrow after each image except the last one
      if (index < stageData.images.length - 1) {
        const arrowWrapper = document.createElement("div");
        arrowWrapper.innerHTML = arrowSvgImage;
        arrowWrapper.className = "stage-arrow";
        imageWrapper.appendChild(arrowWrapper);
      }
    });
    
    stageContainer.appendChild(imageWrapper);
  }
}

function removeLoader() {
  let buyButtonLoader = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonLoader.forEach((eachBtn) => {
    eachBtn.innerHTML = "Buy Now";
    eachBtn.classList.remove('loader-added')
    eachBtn.disabled = false;
 });
}
  
function showOrHide(partition, state) {
  partition.forEach((part) => {
    part.style.display = `${state}`;
  })
}

function showOrHideByClass(partition, work, state) {
  partition.forEach((part) => {
    if(work == 'add') {part.classList.add(state)}
    if(work == 'remove') {part.classList.remove(state)}
  })
}

var prices = 0, variantsIDs = [];
function getProductByHandle(response) {
  let resultTotalPrice = document.querySelectorAll('.total-price');
  let strikeTotalPrice = document.querySelectorAll('.strike-cart-total-price');
  const strikeFinalCartPrice = Math.round(response.newPriceCard.updatedCartPrice);

  if (strikeTotalPrice.length !== 0) {
    strikeTotalPrice.forEach((price) => {
      price.innerHTML = `₹ ${strikeFinalCartPrice + 500}`;
    });
  }

  const finalCartPrice = Math.round(response.cart_price); 
  if(resultTotalPrice.length != 0) {
    resultTotalPrice.forEach((price) => {
      price.innerHTML = `₹ ${finalCartPrice}`
    })
  }
  applyOneMonthDiscount(response);
}

function applyOneMonthDiscount(response) {
  const discountsData = response?.discounts;
  if (!discountsData) return;

  if (!discountsData.discountValidityByPlan?._1Month) return;
  const discountObj = discountsData.discount?.[0];
  if (!discountObj) return;

  const { code, value, validCartValue } = discountObj;
  if (!code || !value || !validCartValue) return;

  const cartTotal = Math.round(response.cart_price);
  if (cartTotal < validCartValue) return;
  
  let discountAmount = 0;

  if (discountObj.type === 'percentage') {
    discountAmount = Math.round((cartTotal * value) / 100);
  } else {
    // default = flat value
    discountAmount = value;
  }

  const discountedTotal = Math.max(cartTotal - discountAmount, 0);

  // const strikeoutPriceAfterDiscount = discountedTotal + 699;
  const discountStrikeElement = Math.round(response.newPriceCard.updatedCartPrice);
  const originalStrikePrice = discountStrikeElement + 500;
  console.log(originalStrikePrice[1])
  const updatedStrikePrice = originalStrikePrice - value;

  // return parseInt(el.textContent.replace(/[^\d]/g, ''), 10) || 0;
  // UI price updates
  document.querySelectorAll('.strike-cart-total-price').forEach(el => {
    el.innerHTML = `₹ ${updatedStrikePrice}`;
  });

  document.querySelectorAll('.total-price').forEach(el => {
    el.innerHTML = `₹ ${discountedTotal}`;
  });
  // Show referral applied UI
  document.querySelectorAll('.refferal-discount-applied').forEach(el => {
    el.classList.remove('d-none');
  });

  // ✅ ONLY store the code
  window.appliedReferralCode = code;
}

function productComboKit(response) {
    const productData = response.product_Ids;
    const priceCart = response.cart_price
    
    let proDetEle = document.querySelector('.product-combo-details');
    const containerDiv = document.createElement('div');
    containerDiv.classList.add('kit-container', 'container');
  
    const header = document.createElement('h2');
    header.classList.add('kit-header', 'section-heading-font');
    header.innerText = 'Month 1 Doctor-Prescribed Kit';
    containerDiv.appendChild(header);
  
    if(window.innerWidth <= 767){
      containerDiv.classList.remove('container');
    }
  
    // Check if the products IDs match
    const matchingExtraData = response.extraDataForProducts.find((extra) => {
      return extra.productId === response.product_Ids[index].product_id;
    });
    
    let dosageTag = '';
    let usageOneLiner = '';
    dosageTag = matchingExtraData?.howToUseData?.dosage_tag;
    usageOneLiner = matchingExtraData?.howToUseData?.usage_one_liner;
  
    productData.forEach((each) => {
      const tagsArray = each.tag.tagKeyArray;
      let tagsHTML = '';
      if (tagsArray.length > 1) {
        tagsHTML = tagsArray
          .map(tag => `<p class="tag-title">${tag}</p>`)
          .join('');
      } else {
        tagsHTML = `<p class="tag-title">${tagsArray[0]}</p>`;
      }
      const productDiv = document.createElement('div');
      productDiv.classList.add('kit-card-container');
      productDiv.dataset.productId = each.product_id;
      productDiv.dataset.productName = each.name;
      productDiv.innerHTML = `
          <div class="reco-pro reco-product-combo">
            <div class="box-separator-line">
              <div class="hairthinning-combo-kit-wrapper">
                ${each.product_id === "45277154377906" ?
                  `<div class="free-product-badge">
                    <img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/free_product_gift.webp?v=1743688549" alt="Free Product Tag" width="24px" height="24px" loading="lazy" class="p-image"/>
                    <p class="free-gift-product">Here’s your Freebie</p>
                  </div>`
                  : ''}
                <div class="hairthinning-combo-kit-container">
                  <div class="p-image-container">
                    <img src="${each.image_url.singleImage}" alt="${each.image_url.singleImage}"  width="100px" height="100px" loading="lazy" class="p-image"/>
                  </div>    
                  <div class="prod-content-wrapper">
                    <div class="p-content-container">
                      <div class="p-title-tag-container">
                        <h2 class="p-title">${each.name}</h2>
                      </div>
                      <div class="p-price-container">
                      <p class="p-price">
                        ${each.product_id === "45277154377906" ? `<del>₹199 </del>` : (each.price ? ` ₹${Math.floor(each.price)}`: `₹${Math.floor(each.price)}`)}
                      </p>
                    </div>
                    <div class="arrow-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="13" viewBox="0 0 7 13" fill="none">
                        <path d="M6.5306 7.03062L1.5306 12.0306C1.3897 12.1715 1.19861 12.2507 0.999348 12.2507C0.80009 12.2507 0.608994 12.1715 0.468098 12.0306C0.327201 11.8897 0.248047 11.6986 0.248047 11.4994C0.248047 11.3001 0.327201 11.109 0.468098 10.9681L4.93747 6.5L0.469348 2.03062C0.399583 1.96086 0.344243 1.87804 0.306486 1.78689C0.26873 1.69573 0.249297 1.59804 0.249297 1.49937C0.249297 1.40071 0.26873 1.30302 0.306486 1.21186C0.344243 1.12071 0.399583 1.03789 0.469348 0.968125C0.539113 0.89836 0.621936 0.843019 0.713088 0.805263C0.80424 0.767507 0.901936 0.748074 1.0006 0.748074C1.09926 0.748074 1.19696 0.767507 1.28811 0.805263C1.37926 0.843019 1.46208 0.89836 1.53185 0.968125L6.53185 5.96812C6.60169 6.03788 6.65707 6.12074 6.69481 6.21195C6.73256 6.30316 6.75193 6.40092 6.75181 6.49963C6.7517 6.59834 6.7321 6.69606 6.69414 6.78718C6.65617 6.8783 6.6006 6.96103 6.5306 7.03062Z" fill="black"/>
                      </svg>
                    </div>
                    </div>
                    <p class="liner-text">${each.oneLiner}</p>
                  </div>
                </div>
                ${dosageTag && usageOneLiner
                ? `<div class="dosage-details--container">
                  <p>${dosageTag}</p>
                  <p>${usageOneLiner}</p>
                </div>`
                : ''}
              </div>
            </div>
          </div>
      `;
      proDetEle.appendChild(productDiv);
      // pushing variant id details to add the products to cart
      if(getCookie("GuestForm_id")){
        variantsIDs.push({
          'id': each.product_id,
          'quantity': 1,
          properties: {
            '_result_id': id
          }
        });
      }else{
        variantsIDs.push({
          'id': each.product_id,
          'quantity': 1
        });
      }
    });
    // Event delegation to handle click on product cards
    document.querySelector('.product-combo-details').addEventListener('click', function(event) {
      const reco = event.target.closest('.kit-card-container');
      if (reco) {
        const productId = reco.getAttribute('data-product-id');
        const productName = reco.getAttribute('data-product-name');
        productFireEvent("web_product_card_clicked", caseId, productName);
        createProductPopup(productId);
      }
    });
}

function fireEvent(eventName, caseID, languageSelected) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "language": languageSelected,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}

function productFireEvent(eventName, caseID, productName) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "productName": productName,
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}

function fireClinicEvent(eventName, caseID) {
  fetch("https://public-jgfas325.hav-g.in/eventMoengageWeb", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer d7ef603e-71ea-44a1-93f2-2bacd08c4a90"
    },
    body: JSON.stringify({
      "eventName": eventName,
      "eventAttributes": {
        "generalAttributes": {
          "platform": "web_shopify",
          "domain": "traya.health",
          "syntheticId": window.location.search.substring(1).split('=')[1] || "default-id"
        }
      },
      "caseId": caseID
    })
  });
}
// WhatsApp Tooltip Animation Function
function initWhatsAppTooltipAnimation() {
  const tooltip = document.querySelector('.whats-app-tooltip');
  if (!tooltip) return;
  function showAndHideTooltip() {
    setTimeout(() => {
      tooltip.classList.add('show');
      tooltip.classList.remove('fade-out');
      setTimeout(() => {
        tooltip.classList.add('fade-out');
        tooltip.classList.remove('show');
      }, 5000);

    }, 10000);
  }
  showAndHideTooltip();
  setInterval(showAndHideTooltip, 15000);
}

function languageSelection() {
  const languageIcon = document.getElementById("language-icon");
  const languageDropdown = document.getElementById("language-dropdown");
  const languageOptions = document.querySelectorAll(".language-option");
  const faqHinglishElements = document.querySelectorAll(".faq-question-answer.hinglish-faq");
  const faqEnglishElements = document.querySelectorAll(".faq-question-answer.english-faq");
  const wrapper = document.querySelector(".faq-hinglish-toggle--wrapper");
  const languageArrow = document.querySelector("#language-icon .language-arrow");
  const languageText = document.querySelector("#language-icon .language-icon"); // Target only the text span

  languageIcon?.addEventListener("click", (e) => {
    e.stopPropagation();
    const isHidden = languageDropdown.classList.contains("hidden");

    languageDropdown.classList.toggle("hidden");
    wrapper.classList.toggle("hidden-dropdown");

    if (languageArrow) {
      languageArrow.classList.toggle("rotate", isHidden);
    }
  });

  languageOptions.forEach((option) => {
    option.addEventListener("click", (e) => {
      const selectedLang = e.target.getAttribute("hreflang");
      const languageSelected = e.target.getAttribute("lang");

      fireEvent("faq_toggle_clicked", caseId, languageSelected);

      languageOptions.forEach(opt => opt.classList.remove("active"));
      e.target.classList.add("active");

      // ✅ Only update the text, NOT the whole button
      // languageText.textContent = selectedLang.toUpperCase();
      languageText.textContent = selectedLang === "hi" ? "HI-EN" : "EN";

      if (selectedLang === "hi") {
        faqHinglishElements.forEach(el => el.classList.remove("d-none"));
        faqEnglishElements.forEach(el => el.classList.add("d-none"));
      } else {
        faqHinglishElements.forEach(el => el.classList.add("d-none"));
        faqEnglishElements.forEach(el => el.classList.remove("d-none"));
      }

      languageDropdown.classList.add("hidden");
      wrapper.classList.add("hidden-dropdown");

      if (languageArrow) {
        languageArrow.classList.remove("rotate");
      }
    });
  });

  document.addEventListener("click", (e) => {
    if (!languageIcon.contains(e.target) && !languageDropdown.contains(e.target)) {
      if (!languageDropdown.classList.contains("hidden")) {
        languageDropdown.classList.add("hidden");
        wrapper.classList.add("hidden-dropdown");
        if (languageArrow) {
          languageArrow.classList.remove("rotate");
        }
      }
    }
  });
}



// timeline section 
function sectionMonthsExpectetion(response) {
  let { monthsExpectation } = response;
  if (monthsExpectation.monthExpectations && monthsExpectation.showComponent == true) {
    const timeline = document.getElementById('timeline');
    // const weeksUpdateElement = document.querySelector('.weeks-update')
    // weeksUpdateElement.innerHTML = monthsExpectation.months;
    monthsExpectation.monthExpectations.forEach((month, index) => {
        const block = document.createElement('div');
        block.className = 'timeline-block';
        block.innerHTML = `
            <div class="timeline-icon">
              <img src="${month.image_url}" alt="Month ${month.month}"  width="100px" height="100px" loading="lazy">
            </div>
            ${index < monthsExpectation.monthExpectations.length - 0 ? `
              <div class="timeline-dot-line">
                <div class="timeline-dot"></div>
                <div class="timeline-line"></div>
              </div>
            ` : ''}
            <div class="timeline-content">
              <p><strong>Month ${month.month}</strong></p>
              <p class="monthe-suggestion">${month.goal}</p>
            </div>
        `;
       timeline.appendChild(block);
    });

    if (timeline) {
      $(timeline).slick({
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
      });
      if ($(window).width() < 768) {
        $(timeline).slick('unslick');
      }
      if (monthsExpectation.monthExpectations.length <= 4) {
        timeline.classList.add('minus-the-margin');
        $(timeline).slick('unslick');
      }
    }
  }
}
// timeline section end

// custom price 
function customPriceSection(response) {
  let cartPrice = response.cart_price;
  cartPrice = parseFloat(cartPrice).toFixed(2);
  if (cartPrice.endsWith('.00')) {
    cartPrice = parseInt(cartPrice);
  }
  
  const dynamicPriceElements = document.querySelectorAll('#dynamic-price');
  if (dynamicPriceElements.length > 0) {
    dynamicPriceElements.forEach(element => {
      element.innerHTML = cartPrice;
    });
  } else {
    console.error('Price elements not found');
  }
}
// end of custom price

// doctor recomandation section 
function sectionBlocksDisplay(response) {
  let { User_Analysis } = response;
  let stage = User_Analysis.hair_fall_stage;
  const apiSection = document.querySelector('.static-block-container');
  const staticSection = document.querySelector('.block-container');

  const isDesktop = window.matchMedia('(min-width: 768px)').matches;

  if (stage == "No widening" || stage == "Starting to see widening") {
    apiSection.style.display = 'none';
    staticSection.style.display = isDesktop ? 'flex' : 'block';
  } else {
    apiSection.style.display = isDesktop ? 'flex' : 'block';
    staticSection.style.display = 'none';
  }
}
// doctor recomandation section end

// women's stories section function
function sectionWomensStories(response) {
  let { successStories } = response;
  if (successStories.stories && successStories.showComponent == true) {
    const imgCarousel = document.querySelector('.image-carousel');
    const titleElement = document.querySelector('.stories-main-heading');

    // Set title and subtitle
    titleElement.textContent = 'Real Women, Real Stories';

    // Loop through each story to create image elements
    successStories.stories.forEach((storyUrl) => {        
      const imgCarouselBlock = document.createElement('div');
      imgCarouselBlock.className = 'image-carousel-container';
      imgCarouselBlock.innerHTML = `
        <div class="image-carousel--container-img position-relative mx-2">
          <img src="${storyUrl}" alt="Success Story" height="auto" width="auto" loading="lazy" >
        </div>
      `;
      imgCarousel.appendChild(imgCarouselBlock);
    });

    // Initialize the Slick carousel after appending elements
    $(imgCarousel).slick({
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false, 
      dots: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding: "15px",
            dots: true,
          },
        },
      ],
    });
  }
  // setTimeout(() => {
  //   if (trayaProcessingAnimation) {
  //     trayaProcessingAnimation.style.display = 'none';
  //   }
  //   document.body.style.overflow = 'unset';
  // }, 2000);
}
// women's stories section function end

// Function to determine if the device is mobile
function isMobileDevice() {
  return window.innerWidth <= 767;
}

// Function to create and display popup with product details
function createProductPopup(productId) {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  const popupContentPlaceholder = document.getElementById('popup-content-placeholder');
  const siteUrl = {
    dev: { 
      "Link": "formv2s.dev.hav-g.in"
    },
    prod: { 
      "Link": "form.traya.health"
    }
  };

  const iframeUrl = `https://${siteUrl.prod.Link}/product-drawerv2/${productId}`;
  
  // Load external product detail page into popup content placeholder
  popupContentPlaceholder.innerHTML = `
    <iframe src="${iframeUrl}" frameborder="0" width="100%" height="100%"></iframe>
  `;
  
  if (isMobileDevice()) {
    // Mobile view popup from the bottom
    popup.style.bottom = '0';
  } else {
    // Desktop view popup from the right
    popup.style.right = '0';
  }

  overlay.style.display = 'block';
  document.body.style.overflow = 'hidden';
  
  // Close popup when close icon is clicked
  const closeIcon = document.getElementById('close-popup');
  closeIcon.addEventListener('click', function() {
    closeProductPopup();
  });

  // Close popup when overlay is clicked
  overlay.addEventListener('click', function() {
    closeProductPopup();
  });
}

// Function to close the popup
function closeProductPopup() {
  const popup = document.getElementById('product-popup');
  const overlay = document.getElementById('background-overlay');
  
  if (isMobileDevice()) {
    popup.style.bottom = '-100%';
  } else {
    popup.style.right = '-100%';
  }

  overlay.style.display = 'none';
  document.body.style.overflow = '';
}

var clearCart = function() {
  let buyButtonElement = document.querySelectorAll('#add-to-cart-result-page-frp');
  buyButtonElement.forEach((eachBtn) => {
    eachBtn.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0100/1622/7394/files/tube-spinner_clockwise.svg?v=1746524502" class="loader-icon" alt="Loading...">`;
    eachBtn.classList.add('loader-added')
    eachBtn.disabled = true;
  })
  $.getJSON('/cart.js', function(cart) {
    if (cart.item_count === 0) { setTimeout(() => { checkout(); }, 100); return; }
    $.ajax({
      type: "POST",
      url: '/cart/clear.js',
      dataType: 'json',
      success: function() {
        setTimeout(() => {
          checkout();
        }, 100);
      },
      error: function(error) {
        console.error('Error on first clear:', error);
      }
    });
  });
}

function updateCartDrawer() {
  // Step 1: Get current cart contents
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const updates = {};

      cart.items.forEach(item => {
        if (item.quantity === 2) {
          updates[item.key] = 1; // Reduce quantity to 1 if it is exactly 2
        }
      });

      // Step 2: If any item needs update, call /cart/update.js in bulk
      if (Object.keys(updates).length > 0) {
        const body = {
          updates: updates
        };

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        })
        .then(res => res.json())
        .then(() => {
          // Step 3: Proceed to update UI (cart bubble + drawer)
          refreshCartUI();
        })
        .catch(err => console.error('Error updating quantities:', err));
      } else {
        // No updates needed, just refresh UI
        refreshCartUI();
      }
    });
}
function bindCartDrawerEvents() {
  const closeBtn = document.querySelector('.drawer__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      document.querySelector('cart-drawer.drawer')?.classList.remove('active');
      document.querySelector('.cart-drawer__overlay')?.classList.remove('active');
    });
  }
}
function refreshCartUI() {
  // Update cart bubble
  fetch('/?sections=cart-icon-bubble')
  .then(res => res.json())
  .then(data => {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && data['cart-icon-bubble']) {
      cartIconBubble.innerHTML = data['cart-icon-bubble'];
    }
  });

  // Update cart drawer section
  fetch('/?sections=cart-drawer')
  .then(res => res.json())
  .then(data => {
    const cartDrawerHTML = data['cart-drawer'];
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawerHTML) {
      cartDrawer.outerHTML = cartDrawerHTML;

      // Rebind events AFTER new drawer is in DOM
      setTimeout(() => {
        bindCartDrawerEvents?.();
      }, 50);

      // Optional: Hide quantity and remove button
      document.querySelectorAll('.cart-drawer .cart-item cart-remove-button, .cart-drawer quantity-input.quantity').forEach(el => {
        el.style.display = 'none';
      });
    }
  })
  .catch(err => console.error('Error updating cart drawer:', err));
  let drawerTotalPrice = document.querySelectorAll('.totals__subtotal-value .drawer-strike-cart-total-price');
  setTimeout(() => {
    if (drawerTotalPrice.length !== 0) {
      drawerTotalPrice.forEach((price) => {
        price.innerHTML = `₹ ${strikeFinalCartPrice}`;
      });
    }
  },1000 );
}

function checkout() {
  localStorage.setItem('user__gender', user_gender);
  localStorage.setItem('caseId', caseId);
  if(user__gender == 'F') {
    user_gender = 'Female';
  }
  variantsIDs.forEach(e => {
    e.properties = { 'Plan': 'Auto' };
  });

  const formData = {
    items: variantsIDs,
    attributes: {
      first_name: f_name,
      phone: C_number,
      email: C_email,
      caseid: caseId,
      user__gender: user_gender,
      hair_Stage: userHairStage
    }
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(result => {
    localStorage.setItem('User_location', 'cart');
    console.log("Silent checkout complete");
  })
  .catch(error => {
    console.error('Silent checkout error:', error);
  })
  .finally(()=>{
    setTimeout(() => {
      removeLoader();
    }, 800);
    updateCartDrawer();
  });
}

async function ATCFunction() {
  // Fetch cart state first to avoid calling clear.js on an already-empty cart.
  // Excessive clear.js calls on empty carts trigger Cloudflare bot detection on Shopify's CDN.
  try {
    const cartState = await fetch('/cart.js').then(r => r.json());
    if ((cartState.item_count || 0) > 0) {
      await fetch('/cart/clear.js', { method: 'POST' }).then(r => r.json());
    }
  } catch (error) {
    console.error('Clear Cart Error: ', error);
  } finally {
    checkout();
    const addToCartEvent = 'result_add_to_cart';
    const addToCartEventData = { "gender": "Female"};
    Shopify.analytics.publish(addToCartEvent, addToCartEventData);
  }
}

(function () {
  const utmParams = ['utm_source', 'utm_campaign', 'utm_medium'];

  // Save UTM params to localStorage
  const urlParams = new URLSearchParams(window.location.search);
  utmParams.forEach(param => {
    const val = urlParams.get(param);
    if (val) localStorage.setItem(param, val);
  });

  // Prepare attributes object
  const attributes = {};
  utmParams.forEach(param => {
    const val = localStorage.getItem(param);
    if (val) attributes[param] = val;
  });

  if (Object.keys(attributes).length === 0) return;

  function updateWhenCartIsReady() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        if (data.items.length > 0) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes })
          })
            .then(res => res.json())
            .then(() => {
              console.log('Cart attributes updated:', attributes);
            })
            .catch(err => {
              console.error('Failed to update cart:', err);
            });
        } else {
          console.log('Cart empty, retrying...');
          setTimeout(updateWhenCartIsReady, 1000);
        }
      });
  }

  updateWhenCartIsReady();
})();

window.addEventListener('DOMContentLoaded', function() {
  var stickyBtn = document.querySelector('[sticky__btn]');

  if (stickyBtn) {
    stickyBtn.style.display = 'block';
    stickyBtn.style.position = 'fixed';
    stickyBtn.style.bottom = '0';
    stickyBtn.style.right = '0';
    // stickyBtn.style.zIndex = '9999';
  }
  
  var stickyBtn = document.querySelector('[btn_sticky]');

  if (stickyBtn) {
    stickyBtn.style.display = 'block';
    stickyBtn.style.position = 'fixed';
    stickyBtn.style.bottom = '0';
    stickyBtn.style.right = '0';
    // stickyBtn.style.zIndex = '9999';
  }
  const stickyButton = document.querySelector('.template-page.female-result [sticky__btn]');
  const stickyButtonCuticle = document.querySelector('.template-page.female-result [btn_sticky]');
  const addToCartButton = document.getElementById('add-to-cart-result-page-frp');
  
  const addZIndex = (element) => {
    if (element) {
      element.style.zIndex = '9999';
    }
  };

  const removeZIndex = (element) => {
    if (element) {
      element.style.zIndex = '';
    }
  };

  const handleAddToCartClick = () => {
    if (window.matchMedia("(min-width: 768px)").matches) {
      if (stickyButton && stickyButton.style.zIndex === '9999') {
        removeZIndex(stickyButton);
      } else {
        addZIndex(stickyButton);
      }
    }
  };

  if (window.matchMedia("(min-width: 768px)").matches) {
    addZIndex(stickyButton);
  }

  if (addToCartButton) {
    addToCartButton.addEventListener('click', function() {
      handleAddToCartClick();
    });
  }
  
  window.addEventListener('resize', () => {
    if (window.matchMedia("(min-width: 768px)").matches) {
      addZIndex(stickyButton);
    } else {
      removeZIndex(stickyButton);
    }
  });
});